export default function RemoveScanForm() {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-4 rounded-2xl border border-red-500/30 bg-content-dark/60 p-6 text-white shadow-inner shadow-red-500/20">
      <header className="space-y-1 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-red-300/80">Danger zone</p>
        <h2 className="text-2xl font-semibold tracking-tight text-white">Remove current scan</h2>
      </header>
      <p className="text-center text-sm text-white/70">
        Removing this scan deletes the 3D models and all related notes. Make sure you have exported any necessary data before proceeding.
      </p>
    </div>
  );
}
